<kendo-treeview
   [navigable]="false"
   [nodes]="MailingSkillTree"
   [children]="getChildren"
   [hasChildren]="hasChildren"
   kendoTreeViewSelectable
   [selectBy]="'groupKey'"
   [selectedKeys]="selectedKeys$ | async"
   (selectionChange)="onSelectionChange($event)"
   kendoTreeViewExpandable
   [expandBy]="'groupKey'"
   [expandedKeys]="keys$ | async"
   (collapse)="handleCollapse($event)"
   (expand)="handleExpand($event)"
   cdkDropList
   [id]="SKILL_TREEVIEW_NAME"
>
   <ng-template fxFlex.lg kendoTreeViewNodeTemplate let-currentTreeItem>
      <div
         cdkDropList
         [id]="currentTreeItem.groupKey"
         (cdkDropListDropped)="onDrop($event)"
         (cdkDropListEntered)="onDropEntered($event)"
         (cdkDropListExited)="onDropExit()"
         [ngClass]="
            (isMessageDragged$ | async) && !(isMessageDroppable$ | async)
               ? 'sam-cursor-no-drop sam-full-width'
               : 'sam-cursor-default sam-full-width'
         "
      >
         <samweb-skill-browser-mail-detail
            [userId]="userId"
            [brickInstanceId]="brickInstanceId"
            [treeItem]="currentTreeItem"
         >
         </samweb-skill-browser-mail-detail>
      </div>
   </ng-template>
</kendo-treeview>
